import { OptionWithData, PATIENT_TYPE, USAGE_STATUS } from "@shared/interfaces";
import { SensorParameter } from "@shared/models";
import { getTimezoneList } from "@shared/utils";

import { FREQUENCY, GENDER, STATUS } from "./shared";

export const USAGE_STATUS_OPTIONS = [
  {
    label: "Show All",
    value: USAGE_STATUS.ALL,
  },
  {
    label: USAGE_STATUS.AVAILABLE,
    value: USAGE_STATUS.AVAILABLE,
  },
  {
    label: USAGE_STATUS.TAKEN,
    value: USAGE_STATUS.TAKEN,
  },
];

export const PATIENT_TYPE_OPTIONS: OptionWithData<string, string>[] = [
  {
    label: "Show All",
    value: PATIENT_TYPE.ALL,
    data: "type",
  },
  {
    label: PATIENT_TYPE.NEW,
    value: PATIENT_TYPE.NEW,
    data: "type",
  },
  {
    label: STATUS.ACTIVE,
    value: STATUS.ACTIVE,
    data: "status",
  },
  {
    label: STATUS.INACTIVE,
    value: STATUS.INACTIVE,
    data: "status",
  },
];

export const STATUS_OPTIONS = [
  {
    label: "Show All",
    value: STATUS.ALL,
  },
  {
    label: STATUS.ACTIVE,
    value: STATUS.ACTIVE,
  },
  {
    label: STATUS.INACTIVE,
    value: STATUS.INACTIVE,
  },
];

export const SENSOR_PARAMETERS_OPTIONS = [
  {
    label: SensorParameter.HR,
    value: SensorParameter.HR,
  },
  {
    label: SensorParameter.RR,
    value: SensorParameter.RR,
  },
];

export const GENDER_OPTIONS = [
  {
    label: GENDER.MALE,
    value: GENDER.MALE,
  },
  {
    label: GENDER.FEMALE,
    value: GENDER.FEMALE,
  },
];

export const FREQUENCY_OPTIONS = [
  {
    label: FREQUENCY.DAILY,
    value: FREQUENCY.DAILY,
  },
  {
    label: `${FREQUENCY.MONTHLY} (Every first day of month)`,
    value: FREQUENCY.MONTHLY,
  },
  {
    label: `${FREQUENCY.TWICE_PER_WEEK} (Every Monday and Thursday)`,
    value: FREQUENCY.TWICE_PER_WEEK,
  },
  {
    label: `${FREQUENCY.WEEKLY} (Every Monday)`,
    value: FREQUENCY.WEEKLY,
  },
  {
    label: `${FREQUENCY.BIWEEKLY} (On Monday)`,
    value: FREQUENCY.BIWEEKLY,
  },
];

export const ALERT_VALUE_TYPE_OPTIONS = [
  {
    label: "Percentage Value",
    value: "percentage",
  },
  {
    label: "Absolute Value",
    value: "absolute",
  },
  {
    label: "Standard Deviation Value",
    value: "deviation",
  },
];

export const ALERT_SIGNAL_TYPE_OPTIONS = [
  {
    label: "HR",
    value: "hr",
  },
  {
    label: "RR",
    value: "rr",
  },
];

export const ALERT_COMPARISON_TYPE_OPTIONS = [
  {
    label: "Above",
    value: "above",
  },
  {
    label: "Below",
    value: "below",
  },
];

export const ALERT_TYPE_OPTIONS = [
  {
    label: "Informative",
    value: "informative",
  },
  {
    label: "Important",
    value: "critical",
  },
];

export const ASSIGNED_TO_ME_OPTIONS = [
  {
    label: "All patients",
    value: "all",
  },
  {
    label: "Assigned to me",
    value: "assigned",
  },
];

export const TIMEZONE_OPTIONS = getTimezoneList();
